import axios from "axios";
import { BACKEND_URL } from "../../config";
import { decryptResponse, encryptApiKey } from "../../auth/responseDecryption";

const API_KEY = process.env.REACT_APP_API_KEY;

const api = axios.create({
  baseURL: BACKEND_URL,
  headers: { "Content-Type": "application/json" },
});

export const unwrapData = (payload, ...keys) => {
  if (!payload || typeof payload !== "object") {
    return payload;
  }

  for (const key of keys) {
    if (payload[key] !== undefined) {
      return payload[key];
    }
  }

  if (payload.data !== undefined) {
    return payload.data;
  }

  return payload;
};

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem("userInfo");
  if (raw) {
    try {
      const { token } = JSON.parse(raw);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // ignore JSON parse errors
    }
  }
  return config;
});

// 🚀 Request Interceptor to Add Encrypted API Key
api.interceptors.request.use(
  (config) => {
    if (API_KEY) {
      const encryptedKey = encryptApiKey(API_KEY);
      if (encryptedKey) {
        config.headers["api-key"] = encryptedKey;
      } else {
        console.warn("⚠️ Failed to encrypt API key!");
      }
    } else {
      console.warn("⚠️ API key is missing!");
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔓 Decrypt Response
api.interceptors.response.use(
  (response) => {
    if (response.data?.encryptedData) {
      try {
        response.data = decryptResponse(response.data.encryptedData);
      } catch (error) {
        console.error("Failed to decrypt response:", error.message);
      }
    } else {
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default api;
